var _circle, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNew2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 126,
    viewBox: "0 0 109 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 54.238,
    cy: 54.238,
    r: 54.238,
    fill: "#D9D9D9",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.4047 29.1011V39.7716C59.4047 41.2184 59.4047 41.9418 59.6862 42.4944C59.9339 42.9805 60.3291 43.3757 60.8152 43.6234C61.3678 43.905 62.0912 43.905 63.538 43.905H74.2086M64.5713 56.8215H43.9047M64.5713 67.1548H43.9047M49.0713 46.4881H43.9047M59.4047 28.4048H45.9714C41.6309 28.4048 39.4607 28.4048 37.8029 29.2495C36.3447 29.9925 35.1591 31.1781 34.416 32.6364C33.5714 34.2942 33.5714 36.4644 33.5714 40.8048V67.6715C33.5714 72.0119 33.5714 74.1821 34.416 75.8399C35.1591 77.2981 36.3447 78.4837 37.8029 79.2268C39.4607 80.0715 41.6309 80.0715 45.9714 80.0715H62.5047C66.8451 80.0715 69.0153 80.0715 70.6731 79.2268C72.1314 78.4837 73.317 77.2981 74.06 75.8399C74.9047 74.1821 74.9047 72.0119 74.9047 67.6715V43.9048L59.4047 28.4048Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_12318_338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0116 121.476L54.238 120.476L93.4644 121.476V122.425L54.238 123.425L15.0116 122.425V121.476Z",
    fill: "url(#paint0_linear_12318_338)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_12318_338",
    x: 13.0116,
    y: 118.476,
    width: 82.4528,
    height: 6.94922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_12318_338"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12318_338",
    x1: 15.0116,
    y1: 121.951,
    x2: 93.4644,
    y2: 121.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0528846,
    stopColor: "#06378F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#85D4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932692,
    stopColor: "#06378F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew2);
export default __webpack_public_path__ + "static/media/new-2.7f97a07b8c540822b5e5c2dc4a9373e2.svg";
export { ForwardRef as ReactComponent };